import React, { useState, useEffect } from 'react';

const SelectPlayerScreen = ({ data, onSelectPlayer }) => {
  // const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Show loading skeletons first
    setIsLoading(true);
    
    // Simulate loading delay for dramatic effect
    const timer = setTimeout(() => {
      setIsLoading(false);
      
      // Animate player cards after loading
      setTimeout(() => {
        const playerCards = document.querySelectorAll('.player-card');
        playerCards.forEach((card, index) => {
          setTimeout(() => {
            card.classList.add('animate-in');
          }, index * 100);
        });
      }, 100);
    }, 1000);

    return () => clearTimeout(timer);
  }, [data]);

  const handleSelectPlayer = (player) => {
    // setSelectedPlayer(player);
    
    // Remove previous selections
    document.querySelectorAll('.player-card').forEach(card => {
      card.classList.remove('selected');
    });
    
    // Add selection to current card
    const selectedCard = document.querySelector(`[data-player="${player.name}"]`);
    if (selectedCard) {
      selectedCard.classList.add('selected');
    }
    
    setTimeout(() => {
      onSelectPlayer(player);
    }, 300);
  };

  if (!data) return null;

  const LoadingSkeleton = ({ count }) => (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="card-skeleton" />
      ))}
    </>
  );

  return (
    <div className="screen active">
      <div className="card">
        <h2>Choose Your Player</h2>
        <p>Competing Statistic: {data.statistic}</p>
        <div className="player-grid">
          {isLoading ? (
            <LoadingSkeleton count={data.players.length} />
          ) : (
            data.players.map((player) => (
              <div
                key={player.name}
                className="player-card"
                data-player={player.name}
                onClick={() => handleSelectPlayer(player)}
              >
                <h4>{player.name}</h4>
                <div className="player-stats">
                  <div className="stat-item">
                    <span>Choose this cricketer</span>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default SelectPlayerScreen;